import axios from 'axios';
import { all, put, takeLatest } from 'redux-saga/effects';
import {
  deleteIncidentReportFieldFailure,
  deleteIncidentReportFieldRequest,
  deleteIncidentReportFieldSuccess,
  incidentReportFieldResultsFailure,
  incidentReportFieldResultsRequest,
  incidentReportFieldResultsSuccess,
  incidentReportFieldsFailure,
  incidentReportFieldsRequest,
  incidentReportFieldsSuccess,
  updateIncidentReportFieldsFailure,
  updateIncidentReportFieldsRequest,
  updateIncidentReportFieldsSuccess,
} from './actions';
import { INCIDENT_REPORTS_V2 } from 'app/api-routes';
import { deserializeFields, serializeFields } from 'new-design/helpers';
import { ENTITY_STATUS } from 'app/types/constants';

function* incidentReportFieldsSaga({
  payload: {
    setupBuilder = false,
    incidentReportID,
    statuses = [ENTITY_STATUS.ACTIVE, ENTITY_STATUS.DELETED],
  } = {},
}) {
  try {
    const { payload } = yield axios.get(`${INCIDENT_REPORTS_V2}/fields`, {
      params: { incidentReportID, statuses },
    });

    yield put(
      incidentReportFieldsSuccess({
        fields: deserializeFields(payload),
        setupBuilder,
      })
    );
  } catch (err) {
    yield put(incidentReportFieldsFailure(err));
  }
}

function* updateIncidentReportFieldsSaga({ payload: { fields } }) {
  try {
    const { payload } = yield axios.put(`${INCIDENT_REPORTS_V2}/fields`, {
      payload: serializeFields(fields, 'fieldID'),
    });

    yield put(
      updateIncidentReportFieldsSuccess({
        payload,
        fields: fields,
      })
    );
  } catch (err) {
    yield put(updateIncidentReportFieldsFailure(err));
  }
}

function* deleteIncidentReportFieldSaga({ payload: { fieldID } }) {
  try {
    yield axios.delete(`${INCIDENT_REPORTS_V2}/fields/${fieldID}`);

    yield put(deleteIncidentReportFieldSuccess({ fieldID }));
  } catch (err) {
    yield put(deleteIncidentReportFieldFailure(err));
  }
}

function* incidentReportFieldResultsSaga({ payload: incidentReportID }) {
  try {
    const { payload } = yield axios.get(`${INCIDENT_REPORTS_V2}/${incidentReportID}/fields`);

    yield put(
      incidentReportFieldResultsSuccess({
        incidentReportID,
        fieldResults: payload,
      })
    );
  } catch (err) {
    yield put(incidentReportFieldResultsFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(incidentReportFieldsRequest, incidentReportFieldsSaga),
    yield takeLatest(updateIncidentReportFieldsRequest, updateIncidentReportFieldsSaga),
    yield takeLatest(deleteIncidentReportFieldRequest, deleteIncidentReportFieldSaga),
    yield takeLatest(incidentReportFieldResultsRequest, incidentReportFieldResultsSaga),
  ]);
}
